import React from 'react'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ListItem from '@mui/material/ListItem'


function NavItem({text, onClick, selected = false, disabled = false}: {text: string; onClick: () => void; selected?: boolean; disabled?: boolean}) {
  return (
    <ListItem disablePadding>
      <ListItemButton disabled={disabled} onClick={onClick} selected={selected} aria-current={selected ? 'page' : undefined} sx={{textAlign: 'left'}}>
        <ListItemText primary={text}/>
      </ListItemButton>
    </ListItem>
  )
}

export default NavItem
